import { LineChartSolid2Filled } from "@tag/tag-icons";
import { FC } from "react";
import "./monthDayOpenDaily.css";
import { useTheme } from "../../../../../context/themeContext";
import dayjs from "dayjs";
import { Tooltip } from "@tag/tag-components-react-v4";
import { useForecastContext } from "../../../../../context/forecastContext";
import { PeriodTypes } from "../../../../../constants/periodTypes";
import { useForecastQuery } from "../../../../../services/forecastService";
import ErrorMessage from "../../../../errorMessage/errorMessage";
import SkeletonLoader from "../../../../SkeletonLoader";

type MonthDayOpenDailyProps = {
  day: dayjs.Dayjs;
};

const MonthDayOpenDaily: FC<MonthDayOpenDailyProps> = ({ day }) => {
  const { theme } = useTheme();
  const { onPeriodAndDateChange, forecastState } = useForecastContext();
  const { isLoading, isError } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  // to-do - this doesnt look right - fix it
  if (isError) {
    return <ErrorMessage showMessage={false} dataType="" fontSize="8px" />;
  }

  return (
    <div
      className="week-day-open-forecast-container"
      onClick={() => onPeriodAndDateChange(PeriodTypes.DAILY, day.toDate())}
    >
      <Tooltip
        background={theme}
        style={{
          borderRadius: "8px",
          border: "1px solid var(--border-color)",
        }}
        tooltipFor={
          <LineChartSolid2Filled accent="teal" style={{ cursor: "pointer" }} />
        }
      >
        <div className="month-day-opendaily-popover-content">
          Open full forecast for {day.format("MMM DD YYYY")}
        </div>
      </Tooltip>
    </div>
  );
};

export default MonthDayOpenDaily;
